module.exports = __webpack_public_path__ + "static/media/2XL.9c72c57a.jpg";